import { Link } from "react-router-dom";
import { Carousel, Image } from "react-bootstrap";
import Message from "./Message";
import Loader from "./Loader";
import { useGetTopProductsQuery } from "../slices/productsApiSlice";

const ProductCarousel = () => {
  const {data: products, isLoading, error} = useGetTopProductsQuery();
  return (
    isLoading ? <Loader/> : error ? <Message variant="danger">{error?.data?.message||error.error}</Message> : (
      <Carousel pause="hover" className="bg-primary mb-4">
        {products.map((product) => 
          <Carousel.Item key={product._id}>
            <Link to={`/product/${product._id}`}>
              <Image src={product.image} alt={product.name} fluid/>
              <Carousel.Caption className="carousel-caption">
                <h4>{product.name} ₹{product.customization.priceCustomization[0].price} / {product.customization.priceCustomization[0].weight}</h4>
              </Carousel.Caption>
            </Link>
          </Carousel.Item>
        )}
      </Carousel>
    )
  )
}

export default ProductCarousel